import { z } from 'zod';

const DEFAULT_ERROR_MESSAGE = 'This field is required';

const PreviousClinicSchema = z.discriminatedUnion('hasPreviousClinic', [
  z.object({
    hasPreviousClinic: z.literal(false),
    name: z.string().optional(),
    email: z.string().optional(),
  }),
  z.object({
    hasPreviousClinic: z.literal(true),
    name: z.string().min(1, DEFAULT_ERROR_MESSAGE),
    email: z.string().min(1, DEFAULT_ERROR_MESSAGE),
  }),
]);

const RepresentativeSchema = z.discriminatedUnion('isRepresentative', [
  z.object({
    isRepresentative: z.literal(false),
    fullName: z.string().optional(),
    relationship: z.string().optional(),
  }),
  z.object({
    isRepresentative: z.literal(true),
    fullName: z.string().min(1, DEFAULT_ERROR_MESSAGE),
    relationship: z.string().min(1, DEFAULT_ERROR_MESSAGE),
  }),
]);

export const ConsentMedicalRecordsSchema = z.object({
  practitionerType: z.string().min(1, DEFAULT_ERROR_MESSAGE),
  practitionerFullName: z.string().min(1, DEFAULT_ERROR_MESSAGE),
  practitionerClinicName: z.string().min(1, DEFAULT_ERROR_MESSAGE),
  practitionerClinicAddress: z.string().min(1, DEFAULT_ERROR_MESSAGE),
  practitionerClinicPhone: z.string().min(1, DEFAULT_ERROR_MESSAGE),
  practitionerClinicEmail: z.string().optional(),
  previousClinic: PreviousClinicSchema,
  representative: RepresentativeSchema,
  signature: z.string().min(1, DEFAULT_ERROR_MESSAGE),
  signatureDate: z.date(),
});

export type ConsentMedicalRecordsFormValues = z.infer<typeof ConsentMedicalRecordsSchema>;
